import { BaseBlock } from 'concepts/Extraction/Blocks/BaseBlock';
import { generateBlockID } from 'concepts/Extraction/Blocks/generateBlockID';

export type OtherOptionBlock = {
  type: 'OtherOption';
} & BaseBlock;

export const blockIsOtherOption = (
  block: BaseBlock
): block is OtherOptionBlock => block.type === 'OtherOption';

export const newOtherOptionBlock = (): OtherOptionBlock => ({
  type: 'OtherOption',
  id: generateBlockID(),
});
